export const COMPETITIVE_SET_HEADER = "project.creation.competitive.set.header";
export const ADD_COMPETITOR = "project.creation.add.competitor";
export const AUTOCOMPLETE_PLACEHOLDER = "autocomplete.competitive.loader.placeholder.text";
